import {
  get,
  post,
  deletes,
} from './axios.js'



//我的（收藏、课程）
export const myMsg = (data) => {
  return get(`/cloudClass/web/student/my`, data)
}

//报名/收藏/回看提醒
export const action = (data) => {
  return post(`/cloudClass/web/student/action`, data)
}

//取消 报名/收藏/回看取消
export const cancel = (data) => {
  return deletes(`/cloudClass/web/student/cancel`, data)
}


/** 
 * 云课堂信息
 */

//课堂--按模块分类搜索功能
export const cloudClassSearch = (page, data) => {
  return get(`/cloudClass/web/class/cloudClassSearch/${page.pageNum}/${page.pageSize}`, data)
}


//所有正在直播的直播课程列表，按时间倒序，最新在前，支持实时更新
export const queryAllLive = (page, data) => {
  return get(`/cloudClass/web/liveClass/queryAllLive/${page.pageNum}/${page.pageSize}`, data)
}

//进入课堂
export const intoCloudClass = (cloudClassId) => {
  let data = {
    cloudClassId: cloudClassId
  }
  return get(`/cloudClass/web/class/intoCloudClass`, data)
}

//根据ID获取课堂信息
export const getClassDataById = (cloudClassId) => {
  let data = {
    cloudClassId: cloudClassId
  }
  return get(`/cloudClass/web/class/getClassDataById`, data)
}


//课堂评价
export const classEvaluate = (data) => {
  return get(`/cloudClass/web/student/classEvaluate`, data)
}


//查询直播间弹幕记录
export const selectBulletScreenNote = (data) => {
  return get(`/cloudClass/web/bulletscreenchat/selectScreen`, data)
}


/** 
 * 教材信息
 */

//教材预览地址(pdf)
export const previewModle = (fileSavePath) => {
  let data = {
    fileSavePath: fileSavePath
  }
  return get(`/cloudClass/web/class/previewModle`, data)
}

//按照教材id查看教材
export const getTextBook = (textBookId) => {
  return get(`/cloudClass/web/textbook/selectOne/${textBookId}`)
}

//按条件查询教材
export const selectTextBook = (page, data) => {
  return get(`/cloudClass/web/class/selectTextBookToView/${page.pageNum}/${page.pageSize}`, data)
}

//查询所有科目
export const getAllCourses = () => {
  return get(`/cloudClass/web/class/getCourses`)
}

//获取数据字典列表
export const getSchoolDictInfo = () => {
  return get(`/cloudClass/web/schoolDict/select/getSchoolDictInfo`)
}

//按条件查询字典
export const getSchoolDictsByCondition = (data) => {
  return get(`/cloudClass/web/schoolDict/select/getSchoolDictsByCondition`, data)
}


/** 
 * MQ队列提醒
 */

//清空消息
export const delAllAdvice = (data) => {
  return get(`/cloudClass/web/newsadvice/insertNewAdvice`, data)
}

//添加消息提醒记录
export const insertNewAdvice = (data) => {
  return post(`/cloudClass/web/newsadvice/insertNewAdvice`, data)
}

//查询消息提醒记录
export const getAllAdvice = (page, userId) => {
  let data = {
    userId: userId
  }
  return get(`/cloudClass/web/newsadvice/selectTextBook/${page.pageNum}/${page.pageSize}`, data)
}